<template>
  <el-upload
    ref="upload"
    :action="uploadFileUrl"
    :data="uploadParams"
    list-type="picture-card"
    class="imgUpload"
    :class="{ uploadHidden: fileList.length === limit, limitWidth: limit == 1 }"
    :multiple="false"
    :limit="limit"
    :file-list="fileList"
    :on-error="handleUploadError"
    :on-exceed="handleExceed"
    :before-upload="handleBeforeUpload"
    :on-success="onSuccess"
    :on-remove="onRemove"
    :http-request="handleFileUpload"
  >
    <i class="el-icon-plus"></i>
  </el-upload>
</template>
<script>
import { filesCloudToken } from "@/api/common";
export default {
  props: {
    value: {
      type: String,
      default: "",
    },
    limit: {
      type: Number,
      default: 1,
    },
    // 文件路径
    directory: {
      type: String,
      default: "",
    },
    // 文件类型, 例如['png', 'jpg', 'jpeg']
    fileType: {
      type: Array,
      default: () => ["png", "jpg", "jpeg"],
    },
    fileSize: {
      type: Number,
      default: 10,
    },
  },
  data() {
    return {
      disabled: false,
      uploadFileUrl: `${process.env.VUE_APP_CDN || ""}${filesCloudToken}`, // 上传的图片服务器地址
      uploadParams: {
        dir: this.directory,
      },
      splitFlag: ";",
    };
  },
  computed: {
    fileList() {
      if (this.value) {
        const split = this.value.split(this.splitFlag);
        return split.map((el) => ({ url: el }));
      }
      return [];
    },
  },
  methods: {
    // 上传前校检格式和大小
    handleBeforeUpload(file) {
      // 校检文件类型
      if (this.fileType) {
        const fileName = file.name.split(".");
        const fileExt = fileName[fileName.length - 1];
        const isTypeOk = this.fileType.indexOf(fileExt) >= 0;
        if (!isTypeOk) {
          this.$message.error(
            `文件格式不正确, 请上传${this.fileType.join("/")}格式文件!`
          );
          return false;
        }
      }
      // 校检文件大小
      if (this.fileSize) {
        const isLt = file.size / 1024 / 1024 < this.fileSize;
        if (!isLt) {
          this.$message.error(`上传文件大小不能超过 ${this.fileSize} MB!`);
          return false;
        }
      }
      this.number++;
      return true;
    },
    // 文件个数超出
    handleExceed() {
      this.$message.error(`上传文件数量不能超过 ${this.limit} 个!`);
    },
    // 上传失败
    handleUploadError() {
      this.$message.error("上传文件失败，请重试");
    },
    onRemove(file, fileList) {
      this.$emit("input", fileList.map((el) => el.url).join(this.splitFlag));
    },
    onSuccess(res) {
      const imgs = res.data;
      const originImg = this.value ? this.value.split(this.splitFlag) : [];
      this.$emit("input", originImg.concat(imgs).join(this.splitFlag));
    },

    // 上传失败后，强制移除文件列表中的图片
    removeFailedFile(file) {
      // 获取upload组件实例，清空/移除失败文件
      const uploadInstance = this.$refs.upload;
      if (uploadInstance) {
        uploadInstance.handleRemove(file);
      }
    },

    handleFileUpload(fileobj) {
      let param = new FormData();
      // 上传文件对象 名称file与后台控制器参数要一致
      param.append("file", fileobj.file);
      param.append("dir", this.uploadParams.dir);
      this.$axios
        .post(filesCloudToken, param, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((response) => {
          this.onSuccess(response);
        })
        .catch(() => {
          this.removeFailedFile(fileobj);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.uploadHidden {
  /deep/ .el-upload {
    display: none;
  }
}
.imgUpload {
  height: 148px;
  overflow: hidden;
  /deep/ .el-upload-list__item {
    > img {
      object-fit: contain;
    }
  }
  // /deep/.el-upload-list__item.is-ready {
  //   display: none;
  // }
}
.limitWidth {
  width: 148px;
}
</style>
